import useFeatureFlags from "./useFeatureFlag";

/**
 * Returns true if the current user can access AI chat routes. Unlike
 * useCanAccessCRO, this only checks the feature flag — it does not require
 * admin or FP-employee status. The approval gate component handles the
 * admin/non-admin differentiation at the page level.
 */
export default function useCanAccessAiChat(): boolean {
  const flag = useFeatureFlags();
  return flag("freshpaintAiChat");
}
